import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../../Auth/Api';
import AddUsuarioModal from '../Modals/AddUsuarioModal';
import { customStyles } from '../../../utils/selectStyles';

const UsuariosManager = ({ token, nivel }) => {
    const [showModalAddUsuario, setShowModalAddUsuario] = useState(false);
    const [loadingSaveUser, setLoadingSaveUser] = useState(false);
    const [selectCursos, setSelectCursos] = useState(false);
    
    // Estados para dados
    const [dataCargos, setDataCargos] = useState([]);
    const [dataGestores, setDataGestores] = useState([]);
    const [dataUnidades, setDataUnidades] = useState([]);

    const {
        register,
        handleSubmit,
        control,
        reset,
        setValue,
        setError,
        formState: { errors },
    } = useForm();

    // Carregar cargos
    useEffect(() => {
        async function fetchCargos() {
            try {
                const response = await Api.get(`api/show/cargos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataCargos(response.data.map((cargo) => ({
                    value: cargo.id,
                    label: cargo.nome
                })));
            } catch (error) {
                console.error("Erro ao carregar cargos:", error);
            }
        }
        fetchCargos();
    }, [token]);

    // Carregar gestores
    useEffect(() => {
        async function fetchGestores() {
            try {
                const response = await Api.get(`api/show/gestores`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataGestores(response.data.map((cargo) => ({
                    value: cargo.id,
                    label: cargo.nome_completo
                })));
            } catch (error) {
                console.error("Erro ao carregar gestores:", error);
            }
        }
        fetchGestores();
    }, [token]);

    // Carregar unidades
    useEffect(() => {
        async function fetchUnidades() {
            try {
                const response = await Api.get(`api/show/unidades`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataUnidades(response.data.map((unidade) => ({
                    value: unidade.id,
                    label: unidade.nome
                })));
            } catch (error) {
                console.error("Erro ao carregar unidades:", error);
            }
        }
        fetchUnidades();
    }, [token]);   

    const onSubmitAddUsuario = async (data) => {
        setLoadingSaveUser(true);

        // Formatar os cursos selecionados, se houver
        if (data.cursos && Array.isArray(data.cursos)) {
            data.cursos = data.cursos.map(curso => curso.value);
        }

        // Limpar CPF (remover formatação) e permitir vazio para Administrador
        if (data.cpf) {
            data.cpf = data.cpf.replace(/\D/g, '');
        }
        if (nivel === 'Administrador' && !data.cpf) {
            delete data.cpf;
        }

        try {
            const response = await Api.post("/api/novo-usuario", data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            // Limpar formulário e fechar modal
            reset();
            setValue("nivel", "");
            setValue("codigo", "");
            
            return {
                success: true,
                message: response.data.message || "Usuário cadastrado com sucesso!"
            };
        } catch (error) {
            console.error("Erro ao criar novo usuário:", error);
            
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar usuário"
            };
        } finally {
            setLoadingSaveUser(false);
        }
    };

    const openAddUsuarioModal = () => {
        setShowModalAddUsuario(true);
        reset();
    };

    return {
        openAddUsuarioModal,
        showModalAddUsuario,
        setShowModalAddUsuario,
        loadingSaveUser,
        onSubmitAddUsuario,
        renderModal: (dataCursos) => (
            <AddUsuarioModal
                showModalAddUsuario={showModalAddUsuario}
                setShowModalAddUsuario={setShowModalAddUsuario}
                dataCargos={dataCargos}
                dataUnidades={dataUnidades}
                dataGestores={dataGestores}
                dataCursos={dataCursos}
                customStyles={customStyles}
                nivel={nivel}
                register={register}
                control={control}
                errors={errors}
                handleSubmit={handleSubmit}
                onSubmitAddParticipante={onSubmitAddUsuario}
                loadingSaveUser={loadingSaveUser}
                selectCursos={selectCursos}
                setSelectCursos={setSelectCursos}
                setValue={setValue}
                setError={setError}
            />
        )
    };
};

export default UsuariosManager; 